import { defineStore } from 'pinia'
// @ts-ignore - Vue's generated compatibility declaration omits composition exports.
import { computed, ref } from 'vue'
import onboardingService, { type CompanyRequest, type OnboardingStatus, type PlanRequest } from '@/services/onboarding.service'

export const useOnboardingStore = defineStore('onboarding', () => {
  const status = ref<OnboardingStatus | null>(null)
  const loading = ref(false)

  const isTrial = computed(() => status.value?.stage === 'TRIAL_ACTIVE' || status.value?.stage === 'PAYMENT_PENDING')

  async function refresh() {
    loading.value = true
    try { status.value = await onboardingService.status(); return status.value }
    finally { loading.value = false }
  }
  async function createCompany(data: CompanyRequest) {
    status.value = await onboardingService.createCompany(data)
    return status.value
  }
  async function selectPlan(data: PlanRequest) {
    const result = await onboardingService.selectPlan(data)
    await refresh()
    return result
  }
  function clear() { status.value = null }

  return { status, loading, isTrial, refresh, createCompany, selectPlan, clear }
})
